import {
    COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA,
    COLLECT_KE_THIRD_PARTY_DATA,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    TRIGGER_CALCULATE_MOTORCYCLE_PREMIUM,
    TRIGGER_GET_VALUERS,
    SUBMIT_QUOTE_FORM_DATA,
} from '../../../actions/ugMotorInsurance/quote';
import {
    COLLECT_CAR_DETAILS_FORM_DATA,
    SUBMIT_CAR_DETAILS_FORM_DATA,
} from '../../../actions/ugMotorInsurance/carDetails';
import {
    TRIGGER_GET_NATIONALITIES,
    TRIGGER_SEND_OTP,
    TRIGGER_VALIDATE_OTP,
    SUBMIT_PERSONAL_DETAILS_FORM_DATA,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { TRIGGER_KE_PAYMENTS_STK_PUSH, CHECK_PAYMENTS_STATUS } from '../../../actions/ugMotorInsurance/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { premiumCalculationService } from './premiumCalculation';
import { thirdPartyPremiumCalculationService } from './thirdPartyPremiumCalculation';
import { checkDoubleInsuranceService } from './doubleInsuranceCheck';
import { motorcyclePremiumCalculationService } from './motorCyclePremium';
import { TRIGGER_FETCH_AGENTS } from '../../../actions/ugMotorInsurance/motorAgentModal';
import { getAgentsService } from './agents';
import { getValuersService } from './valuers';
import { getNationalityService } from './nationalities';
import { sendEmailOtpService, validateOtpService } from './emailOtp';
import { shareQuoteService } from './shareQuote';
import { submitQuoteService } from './submitQuoteDetails';
import { submitPersonalDetailsService } from './submitPersonalDetails';
import { submitCarDetailsService } from './submitCarDetails';
import { SUBMIT_DOCUMENTS_DATA } from '../../../actions/ugMotorInsurance/Documents';
import { submitDocumentsService } from './submitDocuments';
import { SUBMIT_PAYMENT_FORM_DATA } from '../../../actions/ugMotorInsurance/payments';
import { submitPaymentDetailsService } from './submitPaymentData';

import {
    INITIATE_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
    PAYSTACK_SUBMIT_PAYMENT,
} from '../../../actions/ugMotorInsurance/paystack';
import { paystackPaymentService, paystackStkStatusService, submitPaymentService } from './paystack';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const keMotorInsuranceCover = (store, next, action) => {
    if (action.type.startsWith(TRIGGER_KE_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(INITIATE_PAYMENT) && gatsbyStack === 'ke') {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS) && gatsbyStack === 'ke') {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT) && gatsbyStack === 'ke') {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(CHECK_PAYMENTS_STATUS) && gatsbyStack === 'ke') {
        return paymentsStkStatusService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_KE_THIRD_PARTY_DATA) && gatsbyStack === 'ke') {
        return thirdPartyPremiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_CAR_DETAILS_FORM_DATA) && gatsbyStack === 'ke') {
        return checkDoubleInsuranceService(store, next, action);
    }

    /*
     if (action.type.startsWith(TRIGGER_CONFIRM_ORDER) && gatsbyStack === 'ke') {
        return orderConfirmationService(store, next, action);
    }
    */

    if (action.type.startsWith(TRIGGER_SEND_OTP)) {
        return sendEmailOtpService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_VALIDATE_OTP)) {
        return validateOtpService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA) && gatsbyStack === 'ke') {
        return shareQuoteService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CALCULATE_MOTORCYCLE_PREMIUM)) {
        return motorcyclePremiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_FETCH_AGENTS)) {
        return getAgentsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_VALUERS)) {
        return getValuersService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_NATIONALITIES)) {
        return getNationalityService(store, next, action);
    }

    /*
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA) && gatsbyStack === 'ke') {
        return payloadSubmitService(store, next, action);
    }
    */

    //tagging
    if (action.type.startsWith(SUBMIT_QUOTE_FORM_DATA)) {
        return submitQuoteService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_PERSONAL_DETAILS_FORM_DATA)) {
        return submitPersonalDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_CAR_DETAILS_FORM_DATA)) {
        return submitCarDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_DOCUMENTS_DATA)) {
        return submitDocumentsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_PAYMENT_FORM_DATA)) {
        return submitPaymentDetailsService(store, next, action);
    }

    return null;
};
